module.exports = __webpack_public_path__ + "static/media/alcogate-5.92a2b95d.jpg";